<template>
  <v-footer
    color="transparent"
    padless
    class="dealer-footer"
    style="background: linear-gradient(135deg, #1a202c 0%, #2d3748 100%);"
  >
    <v-container>
      <v-row class="footer-content">
        <!-- Company Info -->
        <v-col cols="12" md="4" class="footer-section">
          <div class="footer-logo" style="cursor: pointer;" @click="$router.push('/dealers/login')">
            <img
              src="@/assets/img/logo.png"
              alt="AutoSync™"
              height="85"
              class="footer-logo-img"
            />
            <div class="footer-brand-text">
              <span class="footer-brand-name">AutoSyncX™</span>
              <span class="dealer-badge-footer">Dealer Portal</span>
            </div>
          </div>
          <p class="footer-description">
            Connecting dealerships with thousands of referral agents nationwide.
            Expand your reach and boost your sales with AutoSync™.
          </p>
          <div class="social-links">
            <v-btn
              icon
              small
              href="#"
              target="_blank"
              class="social-btn"
            >
              <i class="material-icons-round">facebook</i>
            </v-btn>
            <v-btn
              icon
              small
              href="#"
              target="_blank"
              class="social-btn"
            >
              <i class="material-icons-round">alternate_email</i>
            </v-btn>
            <v-btn
              icon
              small
              href="#"
              target="_blank"
              class="social-btn"
            >
              <i class="material-icons-round">business</i>
            </v-btn>
            <v-btn
              icon
              small
              href="#"
              target="_blank"
              class="social-btn"
            >
              <i class="material-icons-round">camera_alt</i>
            </v-btn>
          </div>
        </v-col>

        <!-- Quick Links -->
        <v-col cols="12" sm="6" md="2" class="footer-section">
          <h4 class="footer-title">Quick Links</h4>
          <ul class="footer-links">
            <li><a href="/dealers" class="footer-link">Home</a></li>
            <li><a href="#" @click.prevent="scrollToCommissionSection" class="footer-link">Pricing</a></li>
            <li><a href="/dealers/about" class="footer-link">About Us</a></li>
            <li class="footer-link">Contact</li>
          </ul>
        </v-col>

        <!-- Services -->
        <v-col cols="12" sm="6" md="2" class="footer-section">
          <h4 class="footer-title">Services</h4>
          <ul class="footer-links">
            <li class="footer-link">Inventory Sync</li>
            <li class="footer-link">Agent Network</li>
            <li class="footer-link">Commission Tracking</li>
            <li class="footer-link">Analytics</li>
            <li class="footer-link">Support</li>
          </ul>
        </v-col>

        <!-- Legal -->
        <v-col cols="12" sm="6" md="2" class="footer-section">
          <h4 class="footer-title">Legal</h4>
          <ul class="footer-links">
            <li><a href="/dealers/terms" class="footer-link">Terms of Service</a></li>
            <li><a href="/dealers/privacy" class="footer-link">Privacy Policy</a></li>
            <li><a href="/dealers/privacy#cookies" class="footer-link">Cookie Policy</a></li>
            <li><a href="/dealers/privacy#compliance" class="footer-link">Compliance</a></li>
          </ul>
        </v-col>

        <!-- Contact Info -->
        <v-col cols="12" sm="6" md="2" class="footer-section">
          <h4 class="footer-title">Contact</h4>
          <div class="contact-info">
            <div class="contact-item">
              <i class="material-icons-round contact-icon" style="font-size: 18px;">phone</i>
              <a href="tel:+1234567890" class="contact-link">+1 602-610-1072</a>
            </div>
            <div class="contact-item">
              <i class="material-icons-round contact-icon" style="font-size: 18px;">email</i>
              <a href="mailto:dealers@autosyncx.com" class="contact-link">dealers@autosyncx.com</a>
            </div>
            <div class="contact-item">
              <i class="material-icons-round contact-icon" style="font-size: 18px;">location_on</i>
              <span class="contact-text">2 N. Central Avenue 19 floor. Phoenix, AZ 85004.</span>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Bottom Bar -->
      <v-divider class="footer-divider"></v-divider>
      <v-row class="footer-bottom">
        <v-col cols="12" md="6" class="text-center text-md-left">
          <p class="copyright">
            © {{ currentYear }} AutoSyncX™. All rights reserved.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "FooterDealer",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },
  methods: {
    scrollToCommissionSection() {
      // Check if we're on the home page
      if (this.$route.path === '/dealers' || this.$route.path === '/dealers/') {
        // We're on the home page, scroll to the section
        const element = document.getElementById('commission-section');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } else {
        // We're on a different page, navigate to home page with hash
        this.$router.push('/dealers#commission-section');
      }
    }
  }
}
</script>

<style scoped>
.dealer-footer {
  margin-top: auto;
  position: relative;
  overflow: hidden;
}

/* Adjust footer for sidebar when in dashboard */
.dealer-footer.with-sidebar {
  margin-left: 250px;
  transition: margin-left 0.3s ease;
}

/* Remove sidebar margin on mobile */
@media (max-width: 960px) {
  .dealer-footer.with-sidebar {
    margin-left: 0;
  }
}



.footer-content {
  padding: 80px 0 50px 0;
  position: relative;
  z-index: 1;
}

.footer-section {
  margin-bottom: 40px;
}

.footer-logo {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}

.footer-logo-img {
  margin-right: 15px;
  filter: brightness(0) invert(1);
  transition: all 0.3s ease;
}

.footer-brand-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.footer-brand-name {
  font-size: 1.4rem;
  font-weight: 700;
  color: #ffffff;
  line-height: 1;
  margin-bottom: 4px;
  font-family: 'Inter', sans-serif;
  letter-spacing: -0.02em;
}

.dealer-badge-footer {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.footer-description {
  color: #cbd5e1;
  line-height: 1.7;
  margin-bottom: 25px;
  font-size: 0.95rem;
  font-family: 'Inter', sans-serif;
  max-width: 350px;
}

.social-links {
  display: flex;
  gap: 12px;
}

.social-btn {
  background-color: rgba(255, 255, 255, 0.08) !important;
  transition: all 0.3s ease !important;
  border-radius: 10px !important;
  width: 40px !important;
  height: 40px !important;
}

.social-btn:hover {
  background-color: rgba(59, 130, 246, 0.2) !important;
  transform: translateY(-3px) !important;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;
}

.footer-title {
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: 700;
  margin-bottom: 25px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  font-family: 'Inter', sans-serif;
  position: relative;
}

.footer-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 30px;
  height: 2px;
  background: linear-gradient(90deg, #3b82f6, #1d4ed8);
  border-radius: 1px;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 14px;
}

.footer-link {
  color: #cbd5e1;
  text-decoration: none;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  font-family: 'Inter', sans-serif;
  position: relative;
  padding-left: 0;
}

.footer-link:hover {
  color: #3b82f6;
  text-decoration: none;
  padding-left: 8px;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  transition: all 0.3s ease;
}

.contact-item:hover {
  transform: translateX(4px);
}

.contact-icon {
  color: #3b82f6;
  margin-top: 2px;
  background: rgba(59, 130, 246, 0.1);
  padding: 6px;
  border-radius: 8px;
  font-size: 16px !important;
}

.contact-link {
  color: #cbd5e1;
  text-decoration: none;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  font-family: 'Inter', sans-serif;
}

.contact-link:hover {
  color: #3b82f6;
  text-decoration: none;
}

.contact-text {
  color: #cbd5e1;
  font-size: 0.9rem;
  line-height: 1.5;
  font-family: 'Inter', sans-serif;
}

.footer-divider {
  border-color: rgba(255, 255, 255, 0.08);
  margin: 30px 0 25px 0;
}

.footer-bottom {
  padding-bottom: 40px;
}

.copyright {
  color: #94a3b8;
  font-size: 0.9rem;
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
}

.footer-bottom-links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.bottom-link {
  color: #94a3b8;
  text-decoration: none;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  font-family: 'Inter', sans-serif;
  padding: 4px 8px;
  border-radius: 6px;
}

.bottom-link:hover {
  color: #3b82f6;
  text-decoration: none;
  background: rgba(59, 130, 246, 0.05);
}

.link-separator {
  color: #64748b;
  font-size: 0.9rem;
  opacity: 0.6;
}

/* Responsive Design */
@media (max-width: 768px) {
  .footer-content {
    padding: 60px 0 40px 0;
  }

  .footer-section {
    margin-bottom: 50px;
    text-align: center;
  }

  .footer-logo {
    justify-content: center;
    margin-bottom: 20px;
  }

  .footer-brand-text {
    align-items: center;
  }

  .footer-description {
    text-align: center;
    margin: 0 auto 20px auto;
  }

  .social-links {
    justify-content: center;
  }

  .contact-item {
    justify-content: center;
    text-align: left;
  }

  .footer-bottom-links {
    flex-direction: column;
    gap: 8px;
  }

  .link-separator {
    display: none;
  }

  .footer-title::after {
    left: 50%;
    transform: translateX(-50%);
  }
}

@media (min-width: 769px) {
  .footer-bottom-links {
    justify-content: flex-end;
  }
}
</style>
